import { ReactNode, Children } from 'react'
import ReactDOM from 'react-dom'
import { Box, TextLink } from '@machobear/design-system'

const Portal = ({ id, children }: { id: string; children: ReactNode }) => {
  if (children === undefined) return null
  const el = document.getElementById(id)
  if (!el) return null
  return ReactDOM.createPortal(children, el)
}

const Icon = (props: { children: ReactNode }) => <Portal {...props} id="header-icon" />
const Title = (props: { children: ReactNode }) => <Portal {...props} id="header-title" />
const Divider = (props: { children: ReactNode }) => <Portal {...props} id="header-divider" />
const Child = (props: { children: ReactNode }) => <Portal {...props} id="header-custom-child" />
export const CustomBackButton = (props: { children: ReactNode }) => (
  <Portal {...props} id="header-custom-back-button" />
)

interface PageTitleProps {
  children: ReactNode
  hideDivider?: boolean
  customChild?: ReactNode
  to?: string
}

const PageTitle = ({ children, hideDivider = false, customChild, to }: PageTitleProps) => {
  if (children === undefined) return null
  const count = Children.count(children)
  const hasIcon = count > 1
  const values = Children.toArray(children)
  const [first, ...rest] = values
  const icons = hasIcon ? first : ''
  const title = hasIcon ? rest : [first, ...rest]
  return (
    <>
      <Icon>{icons}</Icon>
      <Title>{to ? <TextLink href={to}>{title}</TextLink> : title}</Title>
      <Divider>
        {!hideDivider ? (
          <Box role="separator" width="full" height="full" background="neutralLight"></Box>
        ) : null}
      </Divider>
      {customChild && <Child>{customChild}</Child>}
    </>
  )
}

export default PageTitle
